module.exports = __webpack_public_path__ + "img/zone_manager.c9be7305.png";